module.exports = __webpack_public_path__ + "static/media/oval.bebe73a7.svg";